/**
 * Fluxo de status dos tickets de suporte. Mesmo mapa de api/utils/ticketFluxoSuporte.js: o servidor
 * é quem decide; aqui é só para não deixar arrastar um card para uma coluna que seria recusada.
 */

export const STATUS_FLUXO = {
    ABERTO: 'status.aberto',
    EM_ANDAMENTO: 'status.emAndamento',
    AGUARDANDO_INFORMACAO: 'status.aguardandoInformacao',
    ESCALADO_METRICA: 'status.escaladoMetrica',
    ESCALADO_TERCEIROS: 'status.escaladoTerceiros',
    EM_TESTE: 'status.emTeste',
    CONCLUIDO: 'status.concluido',
    CANCELADO: 'status.cancelado'
};

export const CHAVES_SO_SUPORTE = [
    STATUS_FLUXO.AGUARDANDO_INFORMACAO,
    STATUS_FLUXO.ESCALADO_METRICA,
    STATUS_FLUXO.ESCALADO_TERCEIROS,
    STATUS_FLUXO.EM_TESTE
];

const TRANSICOES = {
    [STATUS_FLUXO.ABERTO]: [STATUS_FLUXO.EM_ANDAMENTO, STATUS_FLUXO.AGUARDANDO_INFORMACAO],
    [STATUS_FLUXO.EM_ANDAMENTO]: [STATUS_FLUXO.ESCALADO_TERCEIROS, STATUS_FLUXO.EM_TESTE],
    [STATUS_FLUXO.ESCALADO_METRICA]: [STATUS_FLUXO.EM_TESTE],
    [STATUS_FLUXO.ESCALADO_TERCEIROS]: [STATUS_FLUXO.EM_TESTE],
    [STATUS_FLUXO.EM_TESTE]: [STATUS_FLUXO.CONCLUIDO, STATUS_FLUXO.EM_ANDAMENTO]
};

const STATUS_FINAIS = [STATUS_FLUXO.CONCLUIDO, STATUS_FLUXO.CANCELADO];

/** Encerrar fica liberado aqui porque o administrador pode, com motivo; o servidor confere o papel. */
export function transicaoPermitidaNoQuadro(de, para) {
    if (STATUS_FINAIS.indexOf(para) >= 0) return STATUS_FINAIS.indexOf(de) < 0;
    return (TRANSICOES[de] || []).indexOf(para) >= 0;
}
